import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { MATURITY_LABELS, REVENUE_LABELS, VERTICAL_LABELS, PATH_LABELS } from './constants'
import type { Filters as FiltersType } from './constants'

interface Props {
  filters: FiltersType
  search: string
}

const selectClasses = 'px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring w-full'

function applyFilters(current: FiltersType, search: string, changes: Partial<FiltersType>) {
  const merged = { ...current, ...changes }
  router.get('/cc/panorama_responses', {
    search: search || undefined,
    maturity_level: merged.maturityLevel || undefined,
    respondent_path: merged.respondentPath || undefined,
    revenue_range: merged.revenueRange || undefined,
    vertical: merged.vertical || undefined,
    page: 1,
  }, { preserveState: true })
}

export default function Filters({ filters, search }: Props) {
  const [query, setQuery] = useState(search)

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    applyFilters(filters, query, {})
  }

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6 space-y-3">
      <div className="grid gap-3 md:grid-cols-4">
        <select
          className={selectClasses}
          value={filters.maturityLevel}
          onChange={(e) => applyFilters(filters, search, { maturityLevel: e.target.value })}
        >
          <option value="">Nível de Maturidade</option>
          {Object.entries(MATURITY_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{value} — {label}</option>
          ))}
        </select>

        <select
          className={selectClasses}
          value={filters.respondentPath}
          onChange={(e) => applyFilters(filters, search, { respondentPath: e.target.value })}
        >
          <option value="">Caminho</option>
          {Object.entries(PATH_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>

        <select
          className={selectClasses}
          value={filters.revenueRange}
          onChange={(e) => applyFilters(filters, search, { revenueRange: e.target.value })}
        >
          <option value="">Faturamento</option>
          {Object.entries(REVENUE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>

        <select
          className={selectClasses}
          value={filters.vertical}
          onChange={(e) => applyFilters(filters, search, { vertical: e.target.value })}
        >
          <option value="">Vertical</option>
          {Object.entries(VERTICAL_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>

      <form onSubmit={handleSearch} className="flex items-center gap-2">
        <div className="relative flex-1 max-w-xs">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar por email..."
            className="pl-9 pr-3 py-2 text-sm border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring w-full"
          />
        </div>
        <Button type="submit" variant="outline" size="sm">
          Buscar
        </Button>
      </form>
    </div>
  )
}
